import { Drawer, Hidden, IconButton, List } from "@material-ui/core";
import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { PlayCircleFilled } from "@material-ui/icons";
import classNames from "classnames";
import React from "react";

export default function Sidebar({
  menuItems,
  header,
  footerItems,
}: {
  menuItems: (JSX.Element | null)[];
  footerItems?: (JSX.Element | null)[];
  header?: JSX.Element;
}) {
  const [sidebarOpen, setSidebarOpen] = React.useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleMenuItemClick = () => {
    if (sidebarOpen) {
      toggleSidebar();
    }
  };

  // max-w- must stay in sync with SIDEBAR_OPEN_WIDTH
  // However Tailwind does not accept dynamic classnames
  // Thus hard code it
  const SIDEBAR_OPEN_WIDTH = 270;
  const sidebarClasses =
    "cw-w-full cw-max-w-[270px] cw-bg-gray-50 cw-border-solid cw-border-r-[0.5px] cw-border-r-gray-200 cw-flex-shrink-0 cw-h-auto";
  const sidebarOpenClasses = `cw-w-full cw-max-w-[270px] cw-transition-all cw-ease-in-out`;

  const sidebarClosedClasses =
    "cw-w-full cw-max-w-[60px] cw-transition-all cw-ease-in-out cw-overflow-x-hidden";

  const FooterItems = ({
    footerItems,
    style,
  }: {
    footerItems: (JSX.Element | null)[];
    style?: CSSProperties;
  }) => (
    <div style={style}>
      <List>
        {footerItems.map((footerItem, index) => (
          <div
            key={index}
            onClick={() => {
              handleMenuItemClick();
            }}
          >
            {footerItem}
          </div>
        ))}
      </List>
    </div>
  );

  const renderSidebarTabs = () => {
    return (
      <div className="cw-flex cw-flex-col cw-justify-between cw-h-full">
        <div>
          {header || <div className="cw-pt-4"></div>}
          <List>
            {menuItems.map((menuItem, index) => (
              <div
                key={index}
                onClick={() => {
                  handleMenuItemClick();
                }}
              >
                {menuItem}
              </div>
            ))}
          </List>
        </div>
        {footerItems && (
          <Hidden mdDown>
            <FooterItems style={{ width: SIDEBAR_OPEN_WIDTH }} footerItems={footerItems} />
          </Hidden>
        )}
        {footerItems && (
          <Hidden lgUp>
            <FooterItems footerItems={footerItems} />
          </Hidden>
        )}
      </div>
    );
  };

  return (
    <>
      <Hidden mdDown>
        <div className={sidebarClasses}>{renderSidebarTabs()}</div>
      </Hidden>
      <Hidden lgUp>
        <Drawer
          variant="permanent"
          className={classNames(sidebarClasses, {
            [sidebarOpenClasses]: sidebarOpen,
            [sidebarClosedClasses]: !sidebarOpen,
          })}
          classes={{
            paper: classNames("cw-top-[80px] cw-static cw-bg-gray-50", {
              [sidebarOpenClasses]: sidebarOpen,
              [sidebarClosedClasses]: !sidebarOpen,
            }),
          }}
        >
          <div className={"cw-mt-2 cw-px-2 "}>
            <IconButton
              onClick={toggleSidebar}
              className={classNames("cw-flex cw-text-dusk-standard", {
                ["cw-rotate-180"]: sidebarOpen,
              })}
            >
              <PlayCircleFilled />
            </IconButton>
          </div>
          {renderSidebarTabs()}
        </Drawer>
      </Hidden>
    </>
  );
}
